import React, { useEffect, useState } from "react";
import "./styles.css";

import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/bootstrap.css";

interface IProps {
  value: string;
  setValue?: any;
  setPhoneCount?: React.Dispatch<React.SetStateAction<number | null>>;
  containerStyle?: any;
  inputStyle?: any;
  disabled?: boolean;
  inputProps?: any;
}

const PhoneNumberInput: React.FC<IProps> = ({
  value,
  setValue,
  setPhoneCount,
  containerStyle,
  disabled,
  inputProps,
  inputStyle,
}) => {
  return (
    <PhoneInput
      countryCodeEditable={false}
      inputStyle={{ ...inputStyle, width: "100%", marginLeft: "70px" }}
      country={"in"}
      value={value}
      onChange={(value, country) => {
        if (country) {
          //@ts-ignore
          let count = country?.format.split(".").length - 1;
          setPhoneCount && setPhoneCount(count);
        }
        setValue && setValue(value);
      }}
      containerStyle={containerStyle ? containerStyle : null}
      defaultErrorMessage={"invalid number"}
      disabled={disabled && disabled}
    />
  );
};

export default PhoneNumberInput;
